import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import { BrandMark, Button, Input, Label } from "../components/ui-kit";
import PasswordInput from "../components/PasswordInput";

export default function ForgotPassword() {
  const [step, setStep] = useState("request");
  const [identifier, setIdentifier] = useState("");
  const [code, setCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [cooldown, setCooldown] = useState(0);

  useEffect(() => {
    if (cooldown <= 0) return undefined;
    const timer = setTimeout(() => setCooldown((value) => Math.max(0, value - 1)), 1000);
    return () => clearTimeout(timer);
  }, [cooldown]);

  const requestCode = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const { data } = await api.post("/auth/password-reset/request", { identifier });
      setCooldown(data.cooldown_seconds || 30);
      setStep("confirm");
      toast.success("Code de recuperation envoye par email");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSubmitting(false);
    }
  };

  const confirm = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post("/auth/password-reset/confirm", { identifier, code, new_password: newPassword });
      toast.success("Mot de passe modifie");
      setStep("done");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="relative app-screen bg-premium-grad grain text-foreground">
      <div className="mx-auto flex app-screen max-w-md flex-col items-center justify-center px-5 auth-screen-safe">
        <Link to="/" className="mb-10"><BrandMark /></Link>
        <div className="w-full rounded-3xl glass-strong p-6 glow-blue">
          <div className="mb-5">
            <div className="text-[11px] font-bold uppercase tracking-[0.15em] text-primary">Compte Nexora</div>
            <h1 className="font-heading text-3xl font-bold">Mot de passe oublie</h1>
            <div className="mt-1 text-sm text-muted-foreground">
              Le code est envoye par email avec le nom expediteur Nexora.
            </div>
          </div>

          {step === "request" && (
            <form onSubmit={requestCode} className="space-y-4">
              <div>
                <Label>Email ou telephone</Label>
                <Input value={identifier} onChange={(e) => setIdentifier(e.target.value)} required />
              </div>
              <Button type="submit" className="w-full py-4" disabled={submitting || cooldown > 0}>
                {submitting ? "Envoi..." : cooldown > 0 ? `Renvoyer dans ${cooldown}s` : "Recevoir le code"}
              </Button>
            </form>
          )}

          {step === "confirm" && (
            <form onSubmit={confirm} className="space-y-4">
              <div>
                <Label>Code recu</Label>
                <Input value={code} onChange={(e) => setCode(e.target.value)} required />
              </div>
              <div>
                <Label>Nouveau mot de passe</Label>
                <PasswordInput value={newPassword} onChange={(e) => setNewPassword(e.target.value)} minLength={8} autoComplete="new-password" required />
                <div className="mt-1 text-[10px] text-muted-foreground">8+ caracteres, majuscule, minuscule, chiffre et symbole.</div>
              </div>
              <Button type="button" variant="outline" className="w-full py-3 text-xs" disabled={submitting || cooldown > 0} onClick={requestCode}>
                {cooldown > 0 ? `Nouveau code dans ${cooldown}s` : "Demander un nouveau code"}
              </Button>
              <Button type="submit" className="w-full py-4" disabled={submitting}>
                {submitting ? "Validation..." : "Changer le mot de passe"}
              </Button>
            </form>
          )}

          {step === "done" && (
            <div className="space-y-4">
              <div className="rounded-xl bg-secondary/10 p-4 text-sm text-secondary">
                Votre mot de passe a ete mis a jour.
              </div>
              <Link to="/login">
                <Button className="w-full py-4">Se connecter</Button>
              </Link>
            </div>
          )}

          <div className="mt-6 border-t border-white/10 pt-4 text-center text-xs font-bold uppercase tracking-widest text-muted-foreground">
            <Link to="/login" className="text-primary">Retour connexion</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
